import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import customTranslate from '../../../../customTranslate/customTranslate';
import { FormEditor } from '../../../bpmn.io/@bpmn-io/form-js-editor';
import { Router } from '@angular/router';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { ModalNotifyTypes } from '../modal-notify/modal-notify.component';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppData } from 'src/app/helpers/app-data';

/* declare var FormEditor: any;
 */
declare var fabric: any;


@Component({
  selector: 'app-form-edit',
  templateUrl: './form-edit.component.html',
  styleUrl: './form-edit.component.css'
})
export class FormEditComponent implements OnInit, OnDestroy {



  @ViewChild('ref', { static: true }) private el: ElementRef;
  formID: string | null = null;

  formularioObj : Formulario;
  botonProcesando = false;
  textoBotonProcesando = 'Cargando...';
  formSubmitted: boolean = false;
  formLoaded = '';
  formParse = '';
  dialogComponentCreateFormulario: any;
  private currentFormIdSubscription: Subscription;


   formEditor : any
  // Define el esquema como una constante
  private readonly schema = {
    "schemaVersion": 1,
    "exporter": {
      "name": "form-js",
      "version": "0.1.0"
    },
    "components": [],
    "type": "default"
  };

  constructor(    private elRef: ElementRef,
    private baseService : BaseServiceService,
    private router: Router,
    private http: HttpClient,

  ) { 

    this.formularioObj = new Formulario();

  }

/*   ngAfterContentInit(): void {
    
    setTimeout(() => {
      const poweredByElement = document.querySelector('.fjs-powered-by');
      
      
    }, 5000); */
    
    // Verifica si el elemento existe antes de intentar eliminarlo
   /*  if (poweredByElement) {
      
      
      // Elimina el elemento del DOM
      //poweredByElement.parentNode.removeChild(poweredByElement);
    }else{
      

    } */

    customTranslateModule = {
      translate: [ 'value', customTranslate ]
    };


  ngOnInit(): void {
    // Obtén el contenedor
    const container = document.querySelector('#form');

    this.currentFormIdSubscription = this.baseService.currentFormId.subscribe(formId=>{
      this.formID = formId;
      this.getFormConfig().subscribe(response => {
        
        this.formLoaded = response.Data.Configuracion
        this.formParse = JSON.parse(this.formLoaded)
        this.formularioObj.FormularioBiblioteca = !!response.Data.FormularioBiblioteca;
        console.log(this.formLoaded);
        console.log(this.formParse);
        
        
        this.formEditor.importSchema(this.formParse)
        .then(()=>{
          const poweredByElement = document.querySelector('.fjs-powered-by');
          if (poweredByElement) {
            // Elimina el elemento del DOM
            poweredByElement.parentNode.removeChild(poweredByElement);
          }          
        })

      })
      
    })

    // Crea el editor de formulario
     this.formEditor = new FormEditor({
      container: document.querySelector('#form'),
    });

    try {
    } catch (err) {
      console.log('importing form failed', err);
    }


    const poweredByElement = document.querySelector('.fjs-powered-by');
    if (poweredByElement) {
      // Elimina el elemento del DOM
      poweredByElement.parentNode.removeChild(poweredByElement);
    }          
    var CommandBarElements = document.querySelectorAll(".ms-CommandBar");
    for (var i = 0; i < CommandBarElements.length; i++) {
      new fabric['CommandBar'](CommandBarElements[i]);
    }
    
    var SpinnerElements = document.querySelectorAll('.ms-Spinner');
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric['Spinner'](SpinnerElements[i]);
    }

 
  }


  ngOnDestroy(): void {
    this.currentFormIdSubscription.unsubscribe();
  }


  getFormConfig() : Observable<any>{
    return this.http.get<any>(`${AppData.API_URL}Formulario/GetFormularioConfiguracion?Id=${this.formID}`)
  }


  
  invalidField(fieldName: string): boolean {
    const fieldValue = this.formularioObj[fieldName as keyof Formulario];

    // Verificar si el campo está definido y no es nulo
    if (fieldValue !== undefined && fieldValue !== null) {
        // Si es un string, verificar si está vacío o solo contiene espacios en blanco
        if (typeof fieldValue === 'string') {
            return this.formSubmitted && (!fieldValue.trim());
        }
        // Si es un número, verificar si es NaN (Not a Number)
        else if (typeof fieldValue === 'number') {
            return this.formSubmitted && isNaN(fieldValue);
        }
        // Otros tipos de datos no se consideran inválidos
        else {
            return false;
        }
    }
    // Si el campo es undefined o null, considerarlo inválido
    else {
        return this.formSubmitted;
    }

    
}


  validateFormulario() {
    this.formSubmitted = true;
    return ![
      'Nombre',
      'Descripcion',
      'Estado',
      'Version',

    ].some((field) => this.invalidField(field));
  }


  abrirModalEditarForm() {
    if (this.formularioObj.FormularioBiblioteca) {
      return; // Formulario de biblioteca, bloqueado para edición.
    }
    const dialog = document.querySelector('.editar-formulario');
    this.dialogComponentCreateFormulario = new fabric['Dialog'](dialog);
    this.dialogComponentCreateFormulario.open();
  }
  abrirDatatable() {
    this.router.navigate(['home/formularios']);
  }

  async actualizarFormulario() {
      this.botonProcesando = true;
      try {

        
        const schema = this.formEditor.saveSchema(this.formParse);
        const config = JSON.stringify(schema);
        this.formularioObj.Configuracion = config; 

    } catch (error) {
        // Manejar cualquier error que ocurra al guardar el XML
        console.error('Error al guardar el XML:', error);
        this.botonProcesando = false; 
        return; 
    }
    

      try {
        const response = await this.baseService.update(
          'Formulario/ActualizarFormularioConfiguracion',
          Number(this.formID),
          this.formularioObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateFormulario.close();

          let mensajeError = '<ul>';
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += '</ul>';

          this.baseService.triggerShowModal(
            'Error al actualizar Formulario',
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          

          var example = document.querySelector(".editado");

          var dialog = example.querySelector(".modal-succes");
    
          var dialogComponent = new fabric['Dialog'](dialog);

          dialogComponent.open();
          /* this.baseService.triggerShowModal(
            'Proceso Creado',
            'Se ha almacenado el registro correctamente ',
            ModalNotifyTypes.Success,
            false
          ); */
          this.botonProcesando = false;
        }
      } catch (error:any) {

        this.botonProcesando = false;

      }

  }


}


export class Formulario {
  Nombre: string;
  Descripcion: string;
  Estado:number;
  Version:number;
  Configuracion: string;
/*   UsuariosPermitidos: string;
  RolesPermitidos: string;
  GruposPermitidos: string; */
  TodosUsuarios:boolean;
  Activo:boolean
  // Formulario perteneciente a un proceso de la Biblioteca (Banco de Procesos); no editable.
  FormularioBiblioteca: boolean;

  
  constructor() {
    this.Nombre = '';
    this.Descripcion = '';
    this.Estado = 1;
    this.Version = 0; 
    this.Configuracion = '';
/*     this.UsuariosPermitidos = '';
    this.RolesPermitidos = '';
    this.GruposPermitidos = ''; */
    this.TodosUsuarios = true;
    this.Activo = true;
    this.FormularioBiblioteca = false;
  }
}